import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "DMS",
  standalone: false,
})
export class LatLongToDMSPipe implements PipeTransform {
  transform(dec: number, type?: string): string {
    const decemical = dec;
    if (!dec && dec !== 0) {
      return null;
    }

    const deg = Math.floor(decemical);
    const min = Math.floor((decemical - deg) * 60);
    const sec = ((decemical - deg - min / 60) * 3600).toFixed(2);
    let sym = "";

    if (type && type === "lat") {
      sym = dec >= 0 ? "N" : "S";
    } else if (type && type === "long") {
      sym = dec >= 0 ? "E" : "W";
    }

    return `${deg}°${min}'${sec}" ${sym}`;
  }
}
